import { get } from 'global/lib/lodash';

// Calculates the display of a score based on scorecard config
export const getDisplayScoreLabel = (opt, i, scorecardConfig = null, isOption = false) => {
  if (!scorecardConfig) {
    return get(opt, 'value', i);
  } else {
    const { forceVal } = scorecardConfig;
    const val = get(opt, 'value', 0);

    if (val === null || isNaN(val)) {
      return 'N/A';
    }
    if (forceVal) {
      return val;
    }

    // If a label is set previously, use it -- this ensures that label overrides from the sc are used
    const buttonLabel = get(opt, 'label');
    if (!!buttonLabel && typeof (buttonLabel) === 'string') {
      return buttonLabel;
    }
    if (val === -1) {
      return 'N/O';
    }

    const maxScore = parseFloat(scorecardConfig.maxScore);
    const minScore = parseFloat(scorecardConfig.minScore);
    const displayPercentage = get(scorecardConfig, 'displayPercentage', true);

    if (displayPercentage) {
      return val.toFixed(0) + '%';
    } else {
      const scoreVal = parseFloat(((val / 100) * (maxScore - minScore) + minScore).toFixed(4)) * get(opt, 'weight', 1);
      // To display an exact option value, sometimes we need to round instead of showing the exact calculated value
      // This is to account for the possibility of values in the db that don't precisely correspond to real options,
      // because the database stores all option values as integers.
      //   For example: 33 is a stand-in value for 33.3333 (as 67 is for 66.666666) in a scorecard with display scores of 1-4
      //   In this example, this logic will ensure we display 2 (instead of 1.99 = 33/100 * (4 - 1) + 1)
      //   And 3 (instead of 3.01 = 67/100 * (4 - 1) + 1)
      // However, we only want to do this rounding when explicitly displaying an _option_ and not to change calculated scores.
      return (isOption && Math.abs(maxScore - minScore) > 1) ? Math.round(scoreVal) : scoreVal;
    }
  }
};

// Used to display values in situations separated from the scoring, like a large-screen photo caption or a task
export const getDisplayValue = (opt, scorecardConfig = null) => {
  if (!scorecardConfig) {
    return '';
  }
  return get(scorecardConfig, 'maxScore') === 1 && get(scorecardConfig, 'minScore') === 0
    ? get(opt, 'value') === 100
      ? 'PASS'
      : get(opt, 'value') === -1
        ? 'N/O'
        : 'FAIL'
    : getDisplayScoreLabel(opt, get(opt, 'value'), scorecardConfig);
};

export const getHeatchartScore = (opt, config = {}, slide = [0, 100]) => {
  const max_score = parseFloat(get(config, 'max_score', 1)) || 1;
  const min_score = parseFloat(get(config, 'min_score', 0)) || 0;
  const val = get(opt, 'value', 0);
  const toFix = max_score > 1 ? 2 : 0;
  const configrange = [min_score || 0, max_score || 1].map(p => parseInt(p));
  const isPercent = configrange[1] == 1;

  if (isNaN(val)) {
    return 'N/A'
  } else if (val === -1) {
    return 'N/O'
  }

  let v = ((val / (isPercent ? 1 : 100)) * (max_score - min_score) + min_score) * get(opt, 'weight', 1);

  const hasRange = slide[0] !== 0 || slide[1] !== 100;

  if (hasRange && !isPercent) {
    const diff = configrange[1] - configrange[0];
    const divi = isPercent ? 1 : 100;
    const [min, max] = [((slide[0] / divi) * diff) + configrange[0], ((slide[1] / divi) * diff) + configrange[0]];
    if (v > max) {
      v = max;
    } else if (v < min) {
      v = min;
    }
  }

  return `${v.toFixed(toFix)}${isPercent ? '%' : ''}`;
};

export default getDisplayScoreLabel;
